import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: '',
    user: null
  }),
  getters: {
    isAuthed: (s) => Boolean(s.token),
    displayName: (s) => s.user?.username || s.user?.realName || '用户'
  },
  actions: {
    setAuth(payload) {
      const { token, userId, username, realName, userType, role, bizId, expiresIn } = payload || {}
      this.token = token || ''
      this.user = {
        userId,
        username,
        realName,
        userType,
        role,
        bizId,
        expiresIn
      }
    },
    logout() {
      this.token = ''
      this.user = null
    }
  },
  persist: {
    storage: localStorage,
    paths: ['token', 'user']
  }
})
